module.exports = __webpack_public_path__ + "static/img/manual-1.1635f1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-1.png
// module id = 201p
// module chunks = 4